<div class="g-0">
  <div class="row">
    <div class="col">
      <div class="box-wrapper box-actiuni-cerere" style="border: 2px solid #5eb169">
        <div class="box-content-header" style="background-color: #5eb169;">
          <div class="row p-1">
            <div class="col">
              <mat-card-title>
                <i class="fa-regular fa-pen-to-square"></i>
                <span>Actualizare cerere</span>
              </mat-card-title>
            </div>
          </div>
        </div>
        <div class="box-content-body">
          <div class="col p-2 d-flex justify-content-start">
            <div>
              <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onActionChange($event)"
                value="status">
                <mat-button-toggle value="status">Status</mat-button-toggle>
                <mat-button-toggle value="escaladare">Escaladare</mat-button-toggle>
                <mat-button-toggle value="prioritate">Prioritate</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
          <div class="row">
            <div class="col" *ngIf="selectedActionToggle == 'status'">
              <div>
                <form [formGroup]="sendUpdateStatusForm" (ngSubmit)="submitUpdateStatusMessage()">
                  <div class="row p-1">
                    <div class="col">
                      <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Status</mat-label>
                        <mat-select formControlName="current_status">
                          <mat-option *ngFor="let status of data.statusCerere" [value]="status.id">
                            {{ status.name }}
                          </mat-option>
                        </mat-select>
                        <mat-error>Selectați un status</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row p-1">
                    <div class="col">
                      <div class="fw-bold">Detalii</div>
                      <angular-editor formControlName="message" [config]="editorConfig"></angular-editor>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="col d-flex justify-content-end">
                        <button [disabled]="sendUpdateStatusForm.invalid"
                          class="btn btn-light upload-btn m-3" type="submit">
                          <span class="upload__text">TRIMITE</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="col" *ngIf="selectedActionToggle == 'prioritate'">
              <div>
                <form [formGroup]="sendUpdatePriorityForm" (ngSubmit)="submitUpdatePriorityMessage()">
                  <div class="row p-1">
                    <div class="col">
                      <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Prioritate</mat-label>
                        <mat-select formControlName="id_cerere_priority">
                          <mat-option *ngFor="let row of requestPriorities" [value]="row.id">
                            {{ row.name }}
                          </mat-option>
                        </mat-select>
                        <mat-error>Selectați o prioritate</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row p-1">
                    <div class="col">
                      <div class="fw-bold">Detalii</div>
                      <angular-editor formControlName="message" [config]="editorConfig"></angular-editor>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="col d-flex justify-content-end">
                        <button [disabled]="sendUpdatePriorityForm.invalid"
                          class="btn btn-light upload-btn m-3" type="submit">
                          <span class="upload__text">TRIMITE</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="col" *ngIf="selectedActionToggle == 'escaladare'">
              <div>
                <form [formGroup]="sendUpdateAssigneeForm" (ngSubmit)="submitUpdateAssigneeMessage()">
                  <!-- <div class="row p-1">
                    <div class="col">
                      <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Direcție/Instituție</mat-label>
                        <mat-select formControlName="directie_id" (selectionChange)="onDirectieChange($event.value)">
                          <mat-option *ngFor="let directie of data.directii" [value]="directie.id">
                            {{ directie.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div> -->
                  <div class="row p-1">
                    <div class="col">
                      <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Compartiment/Birou/Serviciu</mat-label>
                        <mat-select formControlName="compartiment_id" (selectionChange)="
                                onCompartimenteResponsabilChange($event.value)
                              ">
                          <mat-option *ngFor="
                                  let compartiment of data.compartimenteAutcom
                                " [value]="compartiment.id">
                            {{ compartiment.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row p-1">
                    <div class="col">
                      <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Operator</mat-label>
                        <mat-select formControlName="user_id">
                          <mat-option *ngFor="let user of usersActive" [value]="user.id">
                            {{ user.name }}
                          </mat-option>
                        </mat-select>
                        <mat-error>Selectați un operator</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row p-1">
                    <div class="col">
                      <div class="fw-bold">Detalii</div>
                      <angular-editor formControlName="message" [config]="editorConfig"></angular-editor>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="col d-flex justify-content-end">
                        <button [disabled]="sendUpdateAssigneeForm.invalid"
                          class="btn btn-light upload-btn m-3" type="submit">
                          <span class="upload__text">TRIMITE</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="section-spinner position-fixed" *ngIf="isLoading">
          <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>